import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Search, ChevronDown } from 'lucide-react'
import { faqData } from '../../content/faqData'

function FaqList({ listClassName = 'max-h-96 overflow-y-auto' }) {
  const [searchTerm, setSearchTerm] = useState('')
  const [expandedFaq, setExpandedFaq] = useState(null)

  const filteredFaqs = faqData.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index)
  }

  return (
    <>
      <div className="relative mb-8">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
        <input
          type="text"
          placeholder="Search questions..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-12 pr-4 py-3.5 border border-gray-200 rounded-xl bg-white focus:ring-2 focus:ring-primary-500/20 focus:border-primary-400 outline-none transition-colors text-gray-900 placeholder-gray-400 shadow-sm"
        />
      </div>

      <div className={`space-y-2 ${listClassName}`}>
        {filteredFaqs.length === 0 ? (
          <p className="text-gray-400 text-center py-12">No questions found.</p>
        ) : (
          filteredFaqs.map((faq, index) => (
            <div
              key={faq.question}
              className="border border-gray-200 rounded-xl overflow-hidden bg-white hover:border-primary-200 transition-colors duration-200"
            >
              <button
                type="button"
                onClick={() => toggleFaq(index)}
                className="w-full text-left px-5 py-4 flex items-center justify-between gap-4 group"
              >
                <span className="font-semibold text-gray-900 group-hover:text-primary-700 transition-colors leading-snug">
                  {faq.question}
                </span>
                <motion.div
                  animate={{ rotate: expandedFaq === index ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                  className="flex-shrink-0"
                >
                  <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-primary-500 transition-colors" />
                </motion.div>
              </button>

              <AnimatePresence initial={false}>
                {expandedFaq === index && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.22, ease: 'easeInOut' }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 pb-5 pt-3 text-gray-600 leading-relaxed border-t border-gray-100">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))
        )}
      </div>

      {filteredFaqs.length > 0 && (
        <p className="text-sm text-gray-400 mt-6 text-center">
          {filteredFaqs.length} of {faqData.length} questions
        </p>
      )}
    </>
  )
}

export default FaqList
